import React from 'react';
import { siteContent } from '../../data/content';
import './Book.css';

const Book = () => {
  return (
    <section id="book" className="book section">
      <div className="container">
        <div className="book__content">
          <div className="book__image">
            <div className="book__cover">
              <a
                href="https://www.fnac.com/a15963905/Valerie-Perez-Ennouchi-Destins-de-femmes"
                target="_blank"
                rel="noopener noreferrer"
                className="book__cover-link"
              >
                <img
                  src="/images/book/book-ddf.jpg"
                  alt="Destins de Femmes - Livre"
                  className="book-cover"
                />
              </a>
              <div className="book__cover-shadow"></div>
            </div>
            <div className="book__awards">
              <div className="book__award">
                <div className="book__award-icon">&#127942;</div>
                <div className="book__award-text">
                  <strong>Prix Edgar Faure</strong>
                  <span>2024</span>
                </div>
              </div>
              <div className="book__award">
                <div className="book__award-icon">&#127775;</div>
                <div className="book__award-text">
                  <strong>Labellisé</strong>
                  <span>Génération Égalité</span>
                </div>
              </div>
              <div className="book__award">
                <div className="book__award-icon">&#127757;</div>
                <div className="book__award-text">
                  <strong>ONU Femmes</strong>
                  <span>France 2023</span>
                </div>
              </div>
            </div>
          </div>

          <div className="book__text">
            <h2 className="book__title">{siteContent.book.title}</h2>
            <p className="book__description">{siteContent.book.description}</p>

            <div className="book__features">
              <div className="book__feature">
                <div className="book__feature-number">17</div>
                <div className="book__feature-text">
                  <strong>Témoignages</strong>
                  <span>de femmes</span>
                </div>
              </div>
              <div className="book__feature">
                <div className="book__feature-number">10</div>
                <div className="book__feature-text">
                  <strong>Années</strong>
                  <span>de recherche</span>
                </div>
              </div>
              <div className="book__feature">
                <div className="book__feature-number">5</div>
                <div className="book__feature-text">
                  <strong>Continents</strong>
                  <span>explorés</span>
                </div>
              </div>
            </div>

            <div className="book__cta">
              <a
                href="https://www.fnac.com/a15963905/Valerie-Perez-Ennouchi-Destins-de-femmes"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary btn-lg"
              >
                Acheter le livre
              </a>
            </div>
          </div>
        </div>

        {/* Nouveau livre : Destins de femmes combattantes */}
        <div className="book__tome2">
          <div className="book__tome2-content">
            <div className="book__tome2-text">
              <div className="book__tome2-badge">Nouveau</div>
              <h3 className="book__tome2-title">{siteContent.book.tome2.title}</h3>
              <p className="book__tome2-publisher">{siteContent.book.tome2.publisher} — {siteContent.book.tome2.date}</p>
              <p className="book__tome2-description">{siteContent.book.tome2.description}</p>
              <div className="book__tome2-cta">
                <a
                  href={siteContent.book.tome2.buyLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary btn-lg"
                >
                  Acheter le livre
                </a>
              </div>
            </div>
          </div>

          <div className="book__tome2-visual">
            <div className="book__tome2-cover">
              <a
                href={siteContent.book.tome2.buyLink}
                target="_blank"
                rel="noopener noreferrer"
                className="book__cover-link"
              >
                <img
                  src={siteContent.book.tome2.cover}
                  alt="Destins de femmes combattantes - Couverture"
                  className="book-cover"
                />
              </a>
              <div className="book__cover-shadow"></div>
            </div>
          </div>
        </div>

        {/* Vidéo de présentation du nouveau livre */}
        <div className="book__presentation">
          <h3 className="book__presentation-title">Présentation du livre</h3>
          <div className="book__instagram-embed">
            <iframe
              src={`${siteContent.book.tome2.presentationVideo}embed/`}
              title="Présentation du nouveau livre – Destins de femmes combattantes"
              allowFullScreen
              scrolling="no"
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Book;

